/**
 * Light or dark on heyday.news. The site and HeyDex under its masthead share one
 * origin and so one `localStorage`: the choice lives under `SITE_APPEARANCE_KEY`,
 * either side's control writes it, and each follows the other through the `storage` event.
 */

export type AppearanceMode = "system" | "light" | "dark";

type Store = Pick<Storage, "getItem" | "setItem" | "removeItem">;

/** The site's choice: `light` or `dark`; absent follows the system. */
export const SITE_APPEARANCE_KEY = "heyday:theme";

export function readSiteAppearance(store: Store): AppearanceMode {
  const value = store.getItem(SITE_APPEARANCE_KEY);
  return value === "light" || value === "dark" ? value : "system";
}

export function writeSiteAppearance(store: Store, mode: AppearanceMode): void {
  if (mode === "system") store.removeItem(SITE_APPEARANCE_KEY);
  else store.setItem(SITE_APPEARANCE_KEY, mode);
}
